import { render, staticRenderFns } from "./CardManutencaoCobranca.vue?vue&type=template&id=3c96b975&scoped=true&"
import script from "./CardManutencaoCobranca.vue?vue&type=script&lang=ts&"
export * from "./CardManutencaoCobranca.vue?vue&type=script&lang=ts&"
import style0 from "./CardManutencaoCobranca.vue?vue&type=style&index=0&id=3c96b975&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c96b975",
  null
  
)

export default component.exports